import React from 'react'
import QuotationManagementPage from './quotation-management-page'

const QuotationWarnings = () => {
	return <QuotationManagementPage isWarning={true} />
}

export default QuotationWarnings
